export const iconFontAwesomeScienceFireFlameCurved = (
	<i className="fa-solid fa-fire-flame-curved"></i>
);
